import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import deepClone from '../../foundation/js/deepClone'
import getLabelFromStore from '../../foundation/js/getLabel'
import SearchFilteredTags from '../SearchFilteredTags/SearchFilteredTags.vue'

export default {
    name: 'RelayList',
    components: {
        SearchFilteredTags
    },
    props: {
        guid: {
            type: String,
            required: true
        },
        skip: {
            type: Number,
            required: true,
            default: 0
        },
        take: {
            type: Number,
            required: true,
            default: 10
        },
        hideNoResults: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    setup(props) {
        const store = useStore()

        onMounted(() => {
            initFetchRelays()
        })

        const totalAmount = computed(() => {
            return store.state.search.scoped_total[props.guid]
        })

        const relays = computed(() => {
            return deepClone(store.state.search.results[props.guid] ?? [])
        })

        const tags = computed(() => {
            return store.getters['search/selectedTags'](props.guid) ?? []
        })

        const showSpinner = computed(
            () => store.state.search.search_inprogress[props.guid]
        )

        const resultCount = computed(() => {
            return relays.value.length
        })

        const getLabel = (key, strings) => {
            let label = getLabelFromStore({
                labelKey: key,
                labelCollection: 'relayList'
            })

            if (strings) {
                strings.forEach((str, index) => {
                    label = label.replace(`{${index}}`, str)
                })
            }

            return label
        }

        const initFetchRelays = function () {
            store.commit('search/set_replaceQueryInUrl', false)

            store.dispatch('search/initSearchScope', {
                guid: props.guid,
                firstPageSize: props.take,
                showMorePageSize: props.take,
                url: process.env.GET_RELAY_LIST
            })


            store.dispatch('search/performZeroSearch', {
                guid: props.guid
            })

            store.dispatch('search/performSearch', {
                guid: props.guid,
                query: '',
                skip: props.skip,
                take: props.take
            })
        }

        const getMoreResults = () => {
            store.dispatch('search/performMoreSearch', { guid: props.guid })
        }

        const getRelayDescription = (relay) => {
            const dateFromTo = getDateFromTo(relay)
            return `${getLabel('relayDateText')} ${dateFromTo}, kl. ${relay.activeTimeslot}`
        }

        const getDateFromTo = ({ startDate, endDate }) => {

            const timestampStart = new Date(startDate)
            const timestampEnd = new Date(endDate)

            const dateStart = timestampStart.getDate()
            const dateEnd = timestampEnd.getDate()

            const monthStart = timestampStart.toLocaleDateString('da-DK', { month: 'long' })
            const monthEnd = timestampEnd.toLocaleDateString('da-DK', { month: 'long' })

            if (dateStart === dateEnd) {
                return `d. ${dateStart}. ${monthStart}`
            }
            else if (monthStart === monthEnd) {
                return `d. ${dateStart}. - ${dateEnd}. ${monthStart}`
            }
            else {
                return `d. ${dateStart}. ${monthStart} - ${dateEnd}. ${monthEnd}`
            }
        }

        return {
            tags,
            relays,
            showSpinner,
            resultCount,
            totalAmount,
            getLabel,
            getMoreResults,
            getRelayDescription
        }
    }
}
